import React from "react";
import { ImEnvelop, ImLocation, ImPhone } from "react-icons/im";
import { IoIosHelpCircle } from "react-icons/io";
import { IoTimeSharp } from "react-icons/io5";
import Icon from "../common/Icon";

const ContactInfo = ({ item, error }) => {
  const infoBlock =
    "flex items-start gap-5 mt-6 p-5 bg-[#DEE2DD]/40 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300";

  return (
    <div className="py-0  px-2 md:px-0 xl:ps-10 2xl:ps-14 2.5xl:ps-24 md:pe-0">
      {/* Intro Text */}
      {(item.heading || item.shortDescription) && (
        <div className="mb-6 ">
          {item.heading && (
            <p className="text-34pt lg:text-36pt text-secondary leading-none">
              {item.heading}
            </p>
          )}
          {item.shortDescription && (
            <p className="text-20pt md:text-24pt mt-4 font-mono">
              {item.shortDescription}
            </p>
          )}
        </div>
      )}

      {/* Address Section */}
      {(item.addressHeading || item.addressLine1 || item.addressLine2) && (
        <div className={infoBlock}>
          <div className="flex-shrink-0 text-secondary">
            <ImLocation size={28} className="mt-2" />
          </div>
          <div className="lg:min-w-[150px]">
            {item.addressHeading && (
              <p className="text-24pt mb-1">{item.addressHeading}</p>
            )}
            {item.addressLine1 && (
              <p className="text-18pt text-gray-700 font-mono leading-relaxed">
                {item.addressLine1}
              </p>
            )}
            {item.addressLine2 && (
              <p className="text-18pt text-gray-700 font-mono leading-relaxed">
                {item.addressLine2}
              </p>
            )}
          </div>
          <div className=" h-[150px] w-full  flex justify-end">
            <iframe
              title="location-map"
              className="w-full h-[150px]"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${encodeURIComponent(
                `${item.addressLine1}`
              )}&output=embed`}
            ></iframe>
          </div>
        </div>
      )}

      {/* Phone Section */}
      {(item.phoneHeading || item.phone1 || item.phone2) && (
        <div className={infoBlock}>
          <div className="flex-shrink-0 text-secondary">
            <ImPhone size={26} className="mt-2" />
          </div>
          <div>
            {item.phoneHeading && (
              <p className="text-24pt mb-1 text-gray-900">{item.phoneHeading}</p>
            )}
            {item.phone1 && (
              <p className="text-18pt text-gray-700 font-mono leading-relaxed">
                <a
                  href={`tel:${item.phone1}`}
                  title="Click to call"
                  className="text-secondary hover:text-green font-medium transition-colors"
                >
                  {item.phone1}
                </a>
              </p>
            )}
            {item.phone2 && (
              <p className="text-18pt text-gray-700 font-mono leading-relaxed">
                <a
                  href={`tel:${item.phone2}`}
                  title="Click to call"
                  className="text-secondary hover:text-green font-medium transition-colors"
                >
                  {item.phone2}
                </a>
              </p>
            )}
            {item.phone_support_timing && (
              <p className="text-18pt text-gray-700 font-mono leading-relaxed mt-1">
                {item.phone_support_timing}
              </p>
            )}
          </div>
        </div>
      )}

      {/* Email Section */}
      {(item.emailHeading || item.email1 || item.email2) && (
        <div className={infoBlock}>
          <div className="flex-shrink-0 text-secondary">
            <ImEnvelop size={26} className="mt-2" />
          </div>
          <div>
            {item.emailHeading && (
              <p className="text-24pt mb-1 text-gray-900">{item.emailHeading}</p>
            )}
            {item.email1 && (
              <p className="text-18pt text-gray-700 font-mono leading-relaxed">
                <a
                  href={`mailto:${item.email1}`}
                  title="Click to send email"
                  className="text-secondary hover:text-green font-medium transition-colors"
                >
                  {item.email1}
                </a>
              </p>
            )}
            {item.email2 && (
              <p className="text-18pt text-gray-700 font-mono leading-relaxed">
                <a
                  href={`mailto:${item.email2}`}
                  title="Click to send email"
                  className="text-secondary hover:text-green font-medium transition-colors"
                >
                  {item.email2}
                </a>
              </p>
            )}
          </div>
        </div>
      )}
      {(item.dashboard_support_heading || item.dashboard_support_content) && (
        <div className={infoBlock}>
          <div className="flex-shrink-0 text-secondary">
            <Icon icon="profile" size={26} className="mt-2" />
          </div>
          <div>
            {item.dashboard_support_heading && (
              <p className="text-24pt mb-1 text-gray-900">
                {item.dashboard_support_heading}
              </p>
            )}
            {item.dashboard_support_content && (
              <div
                className="text-18pt text-gray-700 font-mono leading-relaxed html"
                dangerouslySetInnerHTML={{
                  __html: item.dashboard_support_content,
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactInfo;
